<template>
  <div>
      <MonacoEditor @change="codeChanged" :options="options" class="editor" :value="code" :language="code_language" theme="vs-dark"/>
     <!-- <iframe id="iframeEditor" :src="changed_code" height="100px" width="100%"></iframe>
      <button v-on:click="runCode">Run Code</button> -->
  </div>
</template>

<script>
import MonacoEditor from 'vue-monaco'

export default {
    name: 'DisplayCodeComponent',
    props: {
        code: String,
        code_language: String
    },
    data: function() {
        return {
            options: {
                automaticLayout: true,
                minimap: false
            },
            changed_code: ''
        }
    },
    components: {
        MonacoEditor
    },
    methods: {
        codeChanged(value, event) {
            this.changed_code = value;
            console.log('code changed, new value is ' + value);
        },

        runCode() {
            /*var Iframe = document.getElementById('iframeEditor');
            Iframe.contentWindow.document.open('text/javascript', 'replace');
            Iframe.contentWindow.document.write(this.changed_code);
            Iframe.contentWindow.document.close();*/
        }
    }
}
</script>

<style>
    .editor {
        width: 100%;
        height: 120px;
    }

    .minimap {
        visibility: hidden;
    }
    
</style>